import React from 'react';
import './SolutionsHeroSection.css';

function SolutionsHeroSection() {
  return (
    <section className="solutions-hero">
      {/* <div className="solutions-hero-content">
        <h1>Innovative Solutions for Your Business</h1>
        <p>Explore our cutting-edge AI-powered solutions tailored to your needs.</p>
      </div> */}
    </section>
  );
}

export default SolutionsHeroSection;

// AI CSR (Customer Service Representative)
// Pet Triage System Using GenAI
// Self-Care AI
// Patient Notes AI
